import { GetRequest, PostRequest } from "../../service"

const ControllerName = "PatientMedicalAttachment"

export const GetPatientMedicalAttachments = (DataObject) =>
    GetRequest(`${ControllerName}/${DataObject?.patientId}?CategoryName=${DataObject?.spText}`)

export const GetPatientAttachmentsTypes = () =>
    GetRequest(`${ControllerName}/lookup/attachment-types`)


export const UploadPatientMedicalAttachment = (data) =>
    PostRequest(`${ControllerName}`, data)
